import { createTheme } from "@mui/material";
import { fontFamily } from "./commonStyles";
import { SECONDARY_THEME_COLOR } from "../consts/colors";

const theme = createTheme({
  palette: {
    primary: {
      main: SECONDARY_THEME_COLOR,
      dark: SECONDARY_THEME_COLOR,
    },
  },
  typography: {
    fontFamily: [fontFamily],
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 610,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  }

});

export default theme;
